export default "__VITE_ASSET__4c564a07__"